import { AxiosError } from 'axios';
import { POST_LOGIN_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

type Input = {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
};

export const usePostLogin = ({ onSuccess, onError }: Input) => {
  const postLogin = async (data: FormData) => {
    await axiosClient.post(POST_LOGIN_URL, data);
  };

  return useCustomMutation(
    postLogin,
    {
      onSuccess,
      onError,
    },
    false
  );
};
